<template>
  <div id="app">
    <NavBar />
    <main class="container">
      <router-view />
    </main>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';
export default {
  components: { NavBar }
}
</script>

<style>
:root { --primary: #2b2d42; --accent: #ef233c; --bg: #f8f9fa; }
body { margin: 0; background: var(--bg); font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; }
.container { max-width: 1000px; margin: 20px auto; padding: 0 16px; }
.card { background: white; border-radius: 12px; padding: 16px; box-shadow: 0 2px 10px rgba(0,0,0,.06); margin-bottom: 16px; }
.btn { display:inline-block; padding: 10px 14px; border-radius: 10px; border: 0; cursor: pointer; background: var(--primary); color: #fff; }
.btn.secondary { background: var(--accent); }
.btn[disabled] { opacity: .6; cursor: not-allowed; }
.input { width: 100%; padding: 10px 12px; border-radius: 10px; border: 1px solid #dcdcdc; }
.row { display: flex; gap: 12px; flex-wrap: wrap; }
.col { flex: 1 1 300px; }
.table { width: 100%; border-collapse: collapse; background: #fff; border-radius: 12px; overflow: hidden; }
.table th, .table td { padding: 10px 12px; border-bottom: 1px solid #eee; text-align: left; }
.table th { background: #f1f3f5; }
.badge { padding: 4px 8px; border-radius: 8px; background: #edf2ff; color: #364fc7; font-size: 12px; }
.nav { display:flex; align-items:center; justify-content:space-between; background:#fff; padding:10px 16px; box-shadow:0 2px 8px rgba(0,0,0,.05); }
</style>
